module.exports = __webpack_public_path__ + "images/application/dns-record-states-204267e3.svg";